(function () {
    
  var sizePrepend = 0
  
  $('.link-list.advanced').each(function(id, elem){
    
    var category = $(this).data().category;
    
    if(category === 'size'){
     
      $(this).remove();
      if(sizePrepend == 0){
      	$('.nav-container').prepend($(this));
      }
       sizePrepend++;
    }
    
    var e = $(this).children('ul');
    
    var items = e.children('li').get();
        
    items.sort(function(a,b){
      	a = $(a).text().trim();
        b = $(b).text().trim();

        if(a == 'S'){
          a = 1000;
        }else if(a == 'M'){
          a = 1001;
        }else if(a == 'L'){
          a = 1002;
        }

        if(b == 'S'){
          b = 1000;
        }else if(b == 'M'){
          b = 1001;
        }else if(b == 'L'){
          b = 1002;
      }
   		return a - b;
	});
    
    $.each(items, function(i, li){
  		e.append(li);
	});    
  });
  
})();